exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_companyInformation_Uj3FGtT90SPgQZ4adH5bF {\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_divider_2QLxKeHLNAl8x34vw8aCNC, .IA_dividerDarkMode_qv-rHo3CxsWbuqnO_1OTl {\n  height: 1px;\n  width: 100%;\n  background-color: #eeeeee;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  float: left;\n}\n\n.IA_billingInfo_2163u3H-DPuaJBYXMCz1QO {\n  font-size: 14px;\n}", ""]);

// Exports
exports.locals = {
	"IA_companyInformation": "IA_companyInformation_Uj3FGtT90SPgQZ4adH5bF",
	"IA_divider": "IA_divider_2QLxKeHLNAl8x34vw8aCNC",
	"IA_dividerDarkMode": "IA_dividerDarkMode_qv-rHo3CxsWbuqnO_1OTl",
	"IA_billingInfo": "IA_billingInfo_2163u3H-DPuaJBYXMCz1QO"
};